export const Accent1 = "#EC008C";
export const Accent2 = "#2D9CDB";
export const Red = "#EB5757";
export const Green = "#3CAE6D";
export const Background = "#F7F9F9";
export const Text = "#0F1C2A";
export const Grey = "#828282";
export const Black = "#000000";
